import { render, staticRenderFns } from "./rand-cooperative-coin.vue?vue&type=template&id=3c59d55b&"
import script from "./rand-cooperative-coin.vue?vue&type=script&lang=js&"
export * from "./rand-cooperative-coin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports